
import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import { errorMessage, successMessage } from "../../../../utils/toastify-message/ToastifyMessage";

const { forwardRef, useRef, useImperativeHandle } = React;

const RejectOrderModal = forwardRef(({ orderData, reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const formHandler = async () => {
    try {
      const path = `api/orders/${orderData._id}/reject`;
      const body = {
        exported: true,
      };
      await putApi({ path, body });
      successMessage("سفارش با موفقیت لغو شد");
      setShowModal(false);
      reGetData();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[320px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>لغو سفارش</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="w-11/12 mx-auto py-8 text-center w-full">
          آیا شما مایل به لغو سفارش {orderData?.trackingCode} هستید؟
        </div>
        <div className="flex gap-2 justify-end w-full">
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            onClick={() => setShowModal(false)}
          >
            بازگشت
          </button>
          <button
            onClick={() => formHandler(true)}
            type="button"
            className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 focus:outline-none dark:focus:ring-red-800"
          >
            لغو سفارش
          </button>
        </div>
      </div>
    </>
  );
});
export default RejectOrderModal;
